import { useNavigate } from "react-router-dom";
import AdnColumn from "../common/adnColumn/AdnColumn";
import { useTranslation } from "react-i18next";

const FollowUpEventsDashboard = ({ employeeFollowUpEventData }) => {
  const { t } = useTranslation();

  const FirstLastName = (name) => {
    const nameArray = name.split(" ");
    const firstName = nameArray[0];
    const lastNameLetter = nameArray[nameArray.length - 1];

    const firstLastName = firstName + " " + lastNameLetter;

    return firstLastName;
  };

  const STATUS_MAPPING = {
    Canceled: { key: "canceled", color: "#9B2020" },
    Done: { key: "done", color: "#0FA958" },
    "Not done": { key: "notDone", color: "#F3983B" },
    "Not Done": { key: "notDone", color: "#F3983B" },
    "Not assigned": { key: "notAssigned", color: "#747985" },
    "Not Assigned": { key: "notAssigned", color: "#747985" },
    Assigned: { key: "assigned", color: "#747985" },
  };

  const statusTranslationCache = {};

  const getStatusInfo = (backendStatus) => {
    const normalized = backendStatus?.toString();
    const mapping = Object.keys(STATUS_MAPPING).find(
      (key) => key.toLowerCase() === normalized.toLowerCase()
    );
    return STATUS_MAPPING[mapping] || { key: "assigned", color: "#747985" };
  };

  const getStatusTranslation = (status) => {
    const statusInfo = getStatusInfo(status);
    const translated = t(`common.status.${statusInfo.key}`);
    statusTranslationCache[translated] = status;
    return translated;
  };

  const getStatusColor = (statusValue) => {
    const backendStatus = statusTranslationCache[statusValue] || statusValue;
    const statusInfo = getStatusInfo(backendStatus);
    return statusInfo.color;
  };
  const employeeFollowUpEventsconfig = {
    height: 420,
    isGroup: true,
    xField: "userName",
    yField: "count",
    minColumnWidth: 30,
    maxColumnWidth: 40,
    dodgePadding:
      employeeFollowUpEventData && employeeFollowUpEventData.length > 2
        ? 2
        : null,
    seriesField: "status",
    color: (data) => {
      const backendStatus =
        data.backendStatus || data.originalStatus || data.status;
      return getStatusColor(backendStatus);
    },
    data: employeeFollowUpEventData
      ? employeeFollowUpEventData.userEmployeeFollowUpEvents?.map((item) => ({
          ...item,
          backendStatus: item.status,
          originalStatus: item.status,
          status: getStatusTranslation(item.status),
        }))
      : [],
    label: {
      position: "middle",
    },
    yAxis: {
      tickInterval: 1,
    },
    xAxis: {
      label: {
        style: {
          fontSize: 11,
        },
        autoRotate: false,
        autoHide: false,
        formatter: (name) => FirstLastName(name),
      },
    },
    scrollbar: {
      type: "horizontal",
      categorySize: 80,
    },
    interactions: [
      {
        type: "element-active",
        cfg: {
          showEnable: [
            { trigger: "element:mouseenter", action: "cursor:pointer" },
            { trigger: "element:mouseleave", action: "cursor:default" },
          ],
        },
      },
    ],
    columnStyle: {
      radius: 16,
    },
  };

  const navigate = useNavigate();

  return (
    <AdnColumn
      navigate={navigate}
      employeeFollowUpEventsconfig={employeeFollowUpEventsconfig}
    ></AdnColumn>
  );
};

export default FollowUpEventsDashboard;
